<template>
  <div>
    <table
      v-if="loading == false"
      class="uk-table metatrader-accounts-table uk-table-hover uk-table-divider"
    >
      <thead>
        <tr>
          <th>LOGIN</th>
          <th>Position</th>
          <th>SYMBOL</th>
          <th>ACTION</th>
          <th>Volume</th>
          <th>Time Create</th>
          <th class="text-right">Price Open</th>
          <th class="text-right">Price SL</th>
          <th class="text-right">Price TP</th>
          <th class="text-right">Price Current</th>
          <th class="text-right">Storage</th>
          <th class="text-right">Profit</th>
        </tr>
      </thead>
      <tbody v-if="results">
        <tr :key="result.Position" v-for="result in results">
          <td>
            <b>{{ result.Login }}</b>
          </td>
          <td>
            {{ result.Position }}
          </td>
          <td>
            <b>{{ result.Symbol }}</b>
          </td>
          <td>{{ actionKey[result.Action] }}</td>
          <td>{{ result.Volume / 1000 }}</td>

          <td>
            {{ result.TimeCreate | formatDate }}
          </td>
          <td class="text-right">{{ result.PriceOpen }}</td>
          <td class="text-right">{{ result.PriceSL }}</td>
          <td class="text-right">{{ result.PriceTP }}</td>
          <td class="text-right">{{ result.PriceCurrent }}</td>
          <td class="text-right">{{ result.Storage }}</td>
          <td class="text-right">{{ result.Profit }}</td>
        </tr>
      </tbody>
    </table>

    <div class="center flex items-center justify-center" v-else>
      <vk-spinner></vk-spinner>
    </div>
  </div>
</template>

<script>
import EventBus from "../../../../components/Ui/EventBus";
import http from "../../../../services/http";
export default {
  props: ["login", "type"],
  data() {
    return {
      loading: true,
      results: [],
      actionKey: ["Alış", "Satış"],
    };
  },
  methods: {
    getData() {
      http.mt5
        .getUserOpenPositions({ login: this.login, type: this.type })
        .then((e) => {
          this.results = e.data.result;
          this.loading = false;
        });
    },
  },
  mounted() {
    EventBus.$on("Services.orders", (login) => {
      this.getData(login);
    });
    this.getData();
  },
};
</script>

<style></style>
